var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TableList',{ref:"table_list",attrs:{"style_mode":"pop","columns":_vm.columns,"where":_vm.where,"is_created_get_list":true,"get_table_list":_vm.get_table_list,"form_data_seo":_vm.form_data_seo,"rowKey":"id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }